import HomeSearch from "../Components/HomeSearch"
import { useSelector } from "react-redux"
import { Typography } from "@mui/material"
import WhiteCard from "../Components/WhiteBox"
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import { useNavigate } from "react-router-dom";
import city from "../features/city";
import Title from "../Components/Title";
import React from "react";
import HomeDailyRecup from "../Components/HomeDailyRecup";



export default function Home() {

  const favuriteCity = useSelector(state => state.favuriteCity).list
  const navigate = useNavigate()

  const handleOpenCity = (city) => {
    navigate('/city/' + city.id)
  }

  return (
    <div>
      <div>
        <div className="container">
          <Title title="My meteo" />
        </div>
        <HomeSearch dfSearch={""}/>
      </div>
      <hr></hr>
      <div className="container">        
        <Typography variant="h6" gutterBottom>Preferiti</Typography>
        {
          favuriteCity.map(c =>
            <WhiteCard key={c.id} id={c} content={<p>{c.name}</p>} icon={<OpenInNewRoundedIcon />} selected={handleOpenCity} />
          )
        }
        <div style={{display:'block', height:'20px'}} ></div>
        <HomeDailyRecup />
      </div>
      <div style={{display: 'block', height:'70px'}}></div>
    </div>
  )
}
